"use client";

import useCenterIdOpenPages from "@portal/hooks/useCenterIdOpenPages";
import { FC } from "react";
import { IThemeProvider } from "./types";
import useAddThemeToHtmlElement from "@portal/hooks/useAddThemeToHtmlElement";

const ThemeProvider: FC<IThemeProvider> = ({ children }) => {
  const centerId = useCenterIdOpenPages();
  useAddThemeToHtmlElement({ centerId });

  return children;
};

export default ThemeProvider;
